export enum LicenseMigrationEvent {
    /**
     * Triggered when admin clicks the "License Migration" button on the Licenses page
     * to navigate to the migration page.
     */
    MigrationPageNavigated = 'LicenseMigration.MigrationPageNavigated',
    /**
     * Triggered when admin clicks the "Migration Guide" button on the migration page.
     */
    MigrationGuideOpened = 'LicenseMigration.MigrationGuideOpened',
    /**
     * Triggered when admin clicks "Start Migration" button on a Flex license card.
     * Properties: { LicenseCode: string }
     */
    MigrationStarted = 'LicenseMigration.MigrationStarted',
    /**
     * Triggered when admin closes the migration modal without applying changes.
     * Properties: { LicenseCode: string, SelectedUsersCount: number, SelectedGroupsCount: number }
     */
    MigrationModalClosed = 'LicenseMigration.MigrationModalClosed',
    /**
     * Triggered when admin clicks "Apply Migration" button to apply the migration.
     * Properties: { LicenseCode: string, TargetLicenseCode: string, UsersCount: number, GroupsCount: number }
     */
    MigrationApplyStarted = 'LicenseMigration.MigrationApplyStarted',
    /**
     * Triggered when migration application fails.
     * Properties: { LicenseCode: string, TargetLicenseCode: string, UsersCount: number, GroupsCount: number, Error: string }
     */
    MigrationApplyFailed = 'LicenseMigration.MigrationApplyFailed',
    /**
     * Triggered when migration application succeeds.
     * Properties: { LicenseCode: string, TargetLicenseCode: string, UsersCount: number, GroupsCount: number }
     */
    MigrationApplySucceeded = 'LicenseMigration.MigrationApplySucceeded',
}

